import tracking from './lib/tracking';

export default tracking;
export * from './lib/tracking';
